<template>
  <div class="screen-my-award wow fadeInDown">
    <div>DANH SÁCH QUÀ CỦA TÔI</div>
    <v-row>
      <v-col
        v-for="(item, index) in myAward"
        :key="index"
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="6"
      >
        <div class="item-my-award">
          <div class="zone-image">
            <img :src="item.image" />
          </div>
          <div class="zone-text">
            <div class="text-description">
              {{ item.name }}
            </div>
            <div class="text-expired">{{ item.expire }}</div>
          </div>
          <div class="zone-button">
            <v-icon>{{ mdiInformationOutline }}</v-icon>
            <span>Dùng Ngay</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiInformationOutline } from "@mdi/js";
export default {
  name: "ScreenMissionAward",
  data() {
    return {
      mdiInformationOutline: mdiInformationOutline,
      myAward: [],
    };
  },
  mounted() {
    this.myAward = [...JSON.parse(localStorage.getItem("myListAward"))];
  },
};
</script>

<style lang="scss">
@import "./screen-my-award.scss";
</style>
